import React, { useRef,useEffect, useState,useContext } from 'react';
import './CustomDropdown.css';
import { AuthContext } from "../Hook/AuthProvider";
import SUBJECT_TOPICS from '../../src/data/mcqdropdown.json';

// by sudz:260925 - Predefined months list for Current Affairs filter
const MONTHS_LIST = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

const CustomDropdown = (props) => {
  const { profileData } = useContext(AuthContext);
  // by sudz - 260926 - Retain filter selections per exam tab (pyq, curated, Current Affairs)
  const currentYearNum = Math.max(2026, new Date().getFullYear());
  const currentYearStr = String(currentYearNum);
  const currentMonthStr = MONTHS_LIST[new Date().getMonth()];
  const months = MONTHS_LIST;

  const getInitialTabFilters = () => {
    try {
      const stored = sessionStorage.getItem("mcq_tab_filters");
      if (stored) return JSON.parse(stored);
    } catch (e) {}
    return {
      pyq: { subjects: [], exams: [], topics: [], theme: [], months: [], years: [] },
      curated: { subjects: [], exams: [], topics: [], theme: [], months: [], years: [] },
      "Current Affairs": {
        subjects: [],
        exams: [],
        topics: [],
        theme: [],
        months: [currentMonthStr],
        years: [currentYearStr],
      },
    };
  };

  const calculateTopicsForSubjects = (subs) => {
    let mergedTopics = [];
    (subs || []).forEach((sub) => {
      if (SUBJECT_TOPICS[sub]) {
        SUBJECT_TOPICS[sub].forEach((t) => {
          mergedTopics.push({
            topicname: t,
            subject: sub,
          });
        });
      }
    });
    return mergedTopics;
  };

  const tabFiltersRef = useRef(getInitialTabFilters());
  const prevTabRef = useRef(props.selectedExamType);

  const initialCurrent =
    tabFiltersRef.current[props.selectedExamType] || {
      subjects: [],
      exams: [],
      topics: [],
      theme: [],
      months: props.selectedExamType === "Current Affairs" ? [currentMonthStr] : [],
      years: props.selectedExamType === "Current Affairs" ? [currentYearStr] : [],
    };

  const [selectedSubjects, setSelectedSubjects] = useState(initialCurrent.subjects || []);
  const [selectedExams, setSelectedExams] = useState(initialCurrent.exams || []);
  const [isExamTypeOpen, setIsExamTypeOpen] = useState(false);
  const [isSubjectOpen, setIsSubjectOpen] = useState(false);
  const [selectedTopics, setSelectedTopics] = useState(initialCurrent.topics || []);
  const [isTopicOpen, setIsTopicOpen] = useState(false);
  const [selectedTheme, setSelectedTheme] = useState(initialCurrent.theme || []);
  const [isThemeOpen, setIsThemeOpen] = useState(false);

  const [selectedMonths, setSelectedMonths] = useState(() =>
    initialCurrent.months && initialCurrent.months.length > 0
      ? initialCurrent.months
      : props.selectedExamType === "Current Affairs"
      ? [currentMonthStr]
      : []
  );
  const [isMonthOpen, setIsMonthOpen] = useState(false);
  const [selectedYears, setSelectedYears] = useState(() =>
    initialCurrent.years && initialCurrent.years.length > 0
      ? initialCurrent.years
      : props.selectedExamType === "Current Affairs"
      ? [currentYearStr]
      : []
  );
  const [isYearOpen, setIsYearOpen] = useState(false);

  const subjects = Object.keys(SUBJECT_TOPICS);
  const [topicsname, setTopicsname] = useState(() =>
    calculateTopicsForSubjects(initialCurrent.subjects)
  );



    const dropdownRefexamtype = useRef(null);
    const dropdownRefsubjectype= useRef(null);
    const dropdownReftopictype = useRef(null);
    const dropdownRefyeartype = useRef(null);
    const dropdownRefmonthtype = useRef(null);


  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {

      if (dropdownRefexamtype.current && !dropdownRefexamtype.current.contains(event.target)) {
        setIsExamTypeOpen(false);
      }
        if ( dropdownRefsubjectype.current && !dropdownRefsubjectype.current.contains(event.target)) {
        setIsSubjectOpen(false);
      }

        if ( dropdownReftopictype.current && !dropdownReftopictype.current.contains(event.target)) {
        setIsTopicOpen(false);
      }
        if ( dropdownRefmonthtype.current && !dropdownRefmonthtype.current.contains(event.target)) {
        setIsMonthOpen(false);
      }
        if ( dropdownRefyeartype.current && !dropdownRefyeartype.current.contains(event.target)) {
        setIsYearOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setIsExamTypeOpen,setIsSubjectOpen, setIsTopicOpen, setIsMonthOpen, setIsYearOpen]);


  // Current Affairs data starts from 2026; dynamically scales up to 2027+
  const years = [];
  for (let y = 2026; y <= currentYearNum; y++) {
    years.push(String(y));
  }

//     const SUBJECT_TOPICS  ={
// 		"AMAC": [
// 				"Architecture",
// 				"Sculpture",
// 				"Indian Paintings",
// 				"Religion",
// 				"Philosophy",
// 				"Indian Music",
// 				"Indian Dance",
// 				"Theatre",
// 				"Puppetry",
// 				"Bhakti & Sufi Movement",
// 				"Languages in India",
// 				"Indian Literature",
// 				"Science & Technology",
// 				"Promotion and Preservation of Indian Heritage",
// 				"Pottery tradition in India",
// 				"Miscellaneous",
// 				"Foreign Travellers",
// 				"Prehistoric period",
// 				"Harappan / Indus Valley Civilization",
// 				"Mahajanapadas and Rise of Magadha - Later Vedic Period ",
// 				"Foreign Invasion",
// 				"Mauryan Age",
// 				"Post Mauryan Age",
// 				"Gupta Age & Post Gupta Age",
// 				"Sangam Age",
// 				"Kingdoms of South India",
// 				"Major Dynasties of Early Medieval Period",
// 				"Rajput States",
// 				"Chola Empire",
// 				"Delhi Sultanate & Provincial Kingdoms",
// 				"Vijayanagara",
// 				"Bahamani Kingdom",
// 				"Mughal Empire ",
// 				"Mughal Administration",
// 				"Maratha ",
// 				"Later Mughals"
// 		],
// 		"Ethics": [
// 				"Ethics and Human Interface",
// 				"Attitude",
// 				"Aptitude",
// 				"Foundational Values",
// 				"Emotions and Intelligence",
// 				"Moral Thinkers and Philosophers of the World and India",
// 				"Ethics and Public administration",
// 				"Probity in Governance",
// 				"Case Studies - Current Affairs from Ethical Point of View"
// 		],
// 		"Polity": [
// 				"Historical background",
// 				"Salient Features of Constitution",
// 				"Union and its Territory",
// 				"Citizenship",
// 				"Fundamental Rights",
// 				"Directive Principles of State Policy/Fundamental Duties",
// 				"Amendment/Basic Structure",
// 				"Government Systems",
// 				"Union Government",
// 				"Council of Ministers",
// 				"Parliament",
// 				"Centre–State Relations",
// 				"Emergency Provisions",
// 				"Committees/Forums/Groups",
// 				"Supreme Court",
// 				"Judicial Review/Activism",
// 				"State Government",
// 				"State Judiciary",
// 				"Special Provisions States",
// 				"Local Government",
// 				"UTs and Special Areas",
// 				"Important Bodies",
// 				"Co-operative Societies",
// 				"Official Language",
// 				"Special Provisions For Certain Classes",
// 				"Elections",
// 				"Electoral Reforms"
// 		],
// 		"Economy": [
// 				"Output of Economy",
// 				"Growth and Development",
// 				"Planning In India",
// 				"Inflation",
// 				"Monetary Policy",
// 				"Banking",
// 				"Capital Market",
// 				"Government Finances",
// 				"Balance of Payments ",
// 				"Exchange Rates ",
// 				"Trade Reforms ",
// 				"Foreign Investments",
// 				"Export-Led Growth",
// 				"Infrastructure",
// 				"Energy Policy ",
// 				"Inclusive Growth",
// 				"Poverty/Social Sector",
// 				"Land Reforms",
// 				"Regional Trading Blocs",
// 				"Global Financial Meltdown",
// 				"Multilateral Institutions",
// 				"Sustainable Development ",
// 				"Towards Globalization",
// 				"India & Globalization"
// 		],
// 		"Geography": [
// 				"Solar System",
// 				"Latitude & longitude",
// 				"Rock, Minerals & Time scale",
// 				"Earth's Interior",
// 				"Tectonic theory",
// 				"Volcanism & Earthquake",
// 				"Denudation & Weathering",
// 				"Landforms",
// 				"Atmosphere-Temp, Pressure & Winds",
// 				"Moisture & Precipitation",
// 				"Oceans",
// 				"Ocean Currents",
// 				"Environment & Oceans",
// 				"Indian Physiography",
// 				"Soil & Vegetation",
// 				"Mineral Resources",
// 				"Industry",
// 				"Agriculture",
// 				"Agriculture Programs",
// 				"Geography & Development",
// 				"Drainage System",
// 				"Transport"
// 		],
// 		"Governance": [
// 				"Basics of Governance",
// 				"E-Governance",
// 				"Transparency & Accountability",
// 				"Role of Civil Services",
// 				"Institutions & Stakeholders",
// 				"Regulatory Bodies",
// 				"Economic Governance",
// 				"Local Governance",
// 				"Urban Governance",
// 				"Civil Society / NGOs",
// 				"Social Justice & Governance",
// 				"Environmental Governance",
// 				"Government Policies",
// 				"Multilateral Stakeholders",
// 				"Role of Media",
// 				"Judicial Governance",
// 				"Ethics in Governance",
// 				"Recent Issues in Governance"
// 		],
// 		"World History": [
// 				"Feudalism",
// 				"The Church rule",
// 				"The Changing Times",
// 				"Modern Era",
// 				"Seven Year Global War (1754-63)",
// 				"American Revolution (1765-1783)",
// 				"French Revolution and Napoleonic Wars",
// 				"Nationalism - Rise and Impact",
// 				"Unification of Germany and of Italy",
// 				"Industrial Revolution",
// 				"Colonialism + Imperialism",
// 				"Colonialism in Africa",
// 				"Colonialism + Imperialist in the world",
// 				"Major events before World War -I",
// 				"Attitude of the Allied Powers & the Peace treaties",
// 				"The World from 1919-23",
// 				"1929 to Second World War",
// 				"After World Wars",
// 				"International Relations",
// 				"Cold War",
// 				"Decolonisation"
// 		],
// 		"Modern History": [
// 				"Advent of the Europeans in India",
// 				"India on the Eve of British Conquest",
// 				"Expansion and Consolidation of British",
// 				"The Revolt of 1857",
// 				"Modern Nationalism in India",
// 				"Indian National Congress",
// 				"Era of Indian Militant Nationalism (1905-1909)",
// 				"First Phase of Revolutionary Activities (1907-1917)",
// 				"First World War and Indian Nationalist Response",
// 				"Era of Mass Nationalism (1919-1930)",
// 				"Civil Disobedience Movement",
// 				"Congress Rule in Provinces",
// 				"Nationalist Response in the Wake of World War II",
// 				"Quit India Movement, Demand for Pakistan, and the INA",
// 				"Post-War National Scenario",
// 				"Independence with Partition",
// 				"Making of the Constitution for India",
// 				"India under British Rule - Governance & other aspects",
// 				"Reform Movements"
// 		],
// 		"Science & Tech": [
// 				"Basics of Science",
// 				"Genetics",
// 				"Biotechnology",
// 				"Information and Communication",
// 				"Artificial Intelligence",
// 				"Space Technology",
// 				"Defence Technolgy",
// 				"Health and Disease",
// 				"Nanotechnology",
// 				"Robotics",
// 				"Nuclear Technology",
// 				"Intellectual Property Rights",
// 				"Contribution of Indian in Science and Technolgy"
// 		],
// 		"Internal Security": [
// 				"Internal Security",
// 				"Border Security",
// 				"Left Wing Extremism",
// 				"Organized Crime",
// 				"Jammu and Kashmir Insurgency",
// 				"Insurgency in North East",
// 				"Maritime Security",
// 				"Cyber Security and its basics",
// 				"Other Hybrid Nature of Security Threats",
// 				"Role of Media and Social Networking Sites",
// 				"Security Infrastructure",
// 				"India’s Security Infrastructure",
// 				"Internal Security Infrastructure of India",
// 				"Shift to ‘Human Security’"
// 		],
// 		"Post Independence": [
// 				"Challenges Before India After Independence",
// 				"Challenge of Building Democracy",
// 				"Evolution of Nationalist Foreign Policy",
// 				"Developments under Nehru’s Leadership",
// 				"Lal Bahadur Shashtri",
// 				"Development of Land Reforms in India",
// 				"Indira Gandhi - First Phase (1966-77)",
// 				"Indira Gandhi - Second Phase (1980-84)",
// 				"Rajiv Gandhi Years",
// 				"VP Singh and Chandra Shekhar Years",
// 				"Narasimha Rao Years",
// 				"NDA Years",
// 				"UPA Years 2004-2014",
// 				"Narendra Modi - Term 1",
// 				"Narendra Modi - Term 2"
// 		],
// 		"International Relations": [
// 				"India and its neighborhood",
// 				"Bilateral relations",
// 				"Regional Groupings",
// 				"International Institutions and Organizations",
// 				"Indian Diaspora",
// 				"Multilateralism and Global Issues",
// 				"Security Issues & India’s Strategic Interests"
// 		],
// 		"Society / Social Justice": [
// 				"Salient features of Indian Society",
// 				"Role of Women and Women’s Issues",
// 				"Population and Associated Issues",
// 				"Poverty and Developmental Issues",
// 				"Social Empowerment",
// 				"Effects of Globalization on Indian Society",
// 				"Trend in Indian Society",
// 				"Welfare Schemes for Vulnerable Sections",
// 				"Issues Related to SCs, STs, OBCs, and Minorities",
// 				"Issues Related to Children",
// 				"Issues Related to the Elderly and Disabled Persons",
// 				"Social Sector and Development",
// 				"Human Rights, Vulnerable Sections & Social Justice",
// 				"Governance, Transparency, and Accountability"
// 		],
// 		"Environment / Disaster Management": [
// 				"Environment & Ecosystem",
// 				"Ecosystem Functions",
// 				"Biogeochemical Cycles",
// 				"Biomes Classification",
// 				"Ecosystem Services",
// 				"Wetland Ecosystem",
// 				"Biodiversity",
// 				"Biodiversity Conservation",
// 				"Forest & programmes",
// 				"Pollution",
// 				"Industrial Pollution",
// 				"Land Degradation",
// 				"Climate Change",
// 				"International Conventions/Laws",
// 				"Environmental Legislations",
// 				"Disaster Management",
// 				"Wildlife Legislations",
// 				"Energy",
// 				"Protected Areas"
// 		]
// };

const theme = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];

  const examtype=[
  {
    "examname": "Full",
    "type": "normal"
  },
  {
    "examname": "Sectional",
    "type": "pro"
  }
]
const isSectionalSelected = selectedExams.some(
  exam => exam.examname === "Sectional"
);
// by sudz:260925 - Reset active tab filters or reset to current month & year on Current Affairs
const clear = () => {
  const currentTab = props.selectedExamType;
  let defMonths = [];
  let defYears = [];
  if (currentTab === "Current Affairs") {
    defMonths = [currentMonthStr];
    defYears = [currentYearStr];
  }
  setSelectedMonths(defMonths);
  setSelectedYears(defYears);
  setSelectedSubjects([]);
  setSelectedExams([]);
  setSelectedTopics([]);
  setSelectedTheme([]);
  setTopicsname([]);

  tabFiltersRef.current[currentTab] = {
    subjects: [],
    exams: [],
    topics: [],
    theme: [],
    months: defMonths,
    years: defYears,
  };
  try {
    sessionStorage.setItem("mcq_tab_filters", JSON.stringify(tabFiltersRef.current));
  } catch (e) {}
};
const hasActiveFilters = [
  selectedMonths,
  selectedYears,
  selectedSubjects,
  selectedExams,
  selectedTopics,
  selectedTheme,
].some(arr => arr.length > 0);

// by sudz - 260926 - Save filters for outgoing tab and restore filters for incoming tab
useEffect(() => {
  const prevTab = prevTabRef.current;
  const currentTab = props.selectedExamType;

  if (prevTab !== currentTab) {
    // 1. Save outgoing tab filters
    tabFiltersRef.current[prevTab] = {
      subjects: selectedSubjects,
      exams: selectedExams,
      topics: selectedTopics,
      theme: selectedTheme,
      months: selectedMonths,
      years: selectedYears,
    };

    // 2. Restore incoming tab filters
    const saved = tabFiltersRef.current[currentTab] || {
      subjects: [],
      exams: [],
      topics: [],
      theme: [],
      months: currentTab === "Current Affairs" ? [currentMonthStr] : [],
      years: currentTab === "Current Affairs" ? [currentYearStr] : [],
    };

    const restoredSubjects = saved.subjects || [];
    setSelectedSubjects(restoredSubjects);
    setSelectedExams(saved.exams || []);
    setSelectedTopics(saved.topics || []);
    setSelectedTheme(saved.theme || []);

    if (currentTab === "Current Affairs") {
      const curMonths = saved.months && saved.months.length > 0 ? saved.months : [currentMonthStr];
      const curYears = saved.years && saved.years.length > 0 ? saved.years : [currentYearStr];
      setSelectedMonths(curMonths);
      setSelectedYears(curYears);
    } else {
      setSelectedMonths(saved.months || []);
      setSelectedYears(saved.years || []);
    }

    setTopicsname(calculateTopicsForSubjects(restoredSubjects));
    prevTabRef.current = currentTab;

    try {
      sessionStorage.setItem("mcq_tab_filters", JSON.stringify(tabFiltersRef.current));
    } catch (e) {}
  }

  setIsExamTypeOpen(false);
  setIsSubjectOpen(false);
  setIsTopicOpen(false);
  setIsMonthOpen(false);
  setIsYearOpen(false);
}, [props.selectedExamType]);


  const handleRemoveSubject = (subject, e) => {
    e.stopPropagation();
    const updatedSubjects = selectedSubjects.filter((s) => s !== subject);
    setSelectedSubjects(updatedSubjects);
    const mergedTopics = calculateTopicsForSubjects(updatedSubjects);
    setTopicsname(mergedTopics);
    setSelectedTopics((prev) =>
      updatedSubjects.length === 0
        ? []
        : prev.filter((t) => mergedTopics.some((mt) => mt.topicname === t.topicname))
    );
  };
 



  const handleRemoveExam = (examObj, e) => {
    e.stopPropagation();
    setSelectedExams((prev) => prev.filter((item) => item.examname !== examObj.examname));
    setSelectedTopics([]);
  };

  const handleExamToggle = (examObj) => {
    setSelectedExams((prev) => {
      const isRemoving = prev.some((item) => item.examname === examObj.examname);
      if (isRemoving) {
        setSelectedTopics([]);
        return prev.filter((item) => item.examname !== examObj.examname);
      }
      return [...prev, examObj];
    });
  };

   const handleRemoveTheme = (month, e) => {
    e.stopPropagation();
    setSelectedTheme(prev => prev.filter(item => item !== month));
  };

  
  const handleThemeToggle = (month) => {
    setSelectedTheme(prev =>
      prev.includes(month)
        ? prev.filter(item => item !== month)
        : [...prev, month]
    );
  };

    const handleRemoveMonth = (month, e) => {
    e.stopPropagation();
    setSelectedMonths(prev => prev.filter(item => item !== month));
  };

  const handleMonthToggle = (month) => {
    setSelectedMonths(prev =>
      prev.includes(month)
        ? prev.filter(item => item !== month)
        : [...prev, month]
    );
  };

  
  const handleRemoveYear = (year, e) => {
    e.stopPropagation();
    setSelectedYears(prev => prev.filter(item => item !== year));
  };

  const handleYearToggle = (year) => {
    setSelectedYears(prev =>
      prev.includes(year)
        ? prev.filter(item => item !== year)
        : [...prev, year]
    );
  };













  // ------------------------------
  // SUBJECT TOGGLE LOGIC
  // ------------------------------
  const handleSubjectToggle = (subject) => {
    let updatedSubjects = [];

    if (selectedSubjects.includes(subject)) {
      updatedSubjects = selectedSubjects.filter((s) => s !== subject);
    } else {
      updatedSubjects = [...selectedSubjects, subject];
    }

    setSelectedSubjects(updatedSubjects);

    // Merge topics of all selected subjects
    let mergedTopics = [];

    updatedSubjects.forEach((sub) => {
      if (SUBJECT_TOPICS[sub]) {
        SUBJECT_TOPICS[sub].forEach((t) => {
          mergedTopics.push({
            topicname: t,
            subject: sub
          });
        });
      }
    });

    setTopicsname(mergedTopics);

    // If no subjects left, clear all topics; otherwise keep only valid topics
    setSelectedTopics((prev) =>
      updatedSubjects.length === 0
        ? []
        : prev.filter((t) =>
            mergedTopics.some((mt) => mt.topicname === t.topicname)
          )
    );
  };

  useEffect(() => {
    if (selectedSubjects.length === 0 && selectedTopics.length > 0) {
      setSelectedTopics([]);
      setTopicsname([]);
    }
  }, [selectedSubjects, selectedTopics.length]);

  // ------------------------------
  // TOPIC TOGGLE LOGIC
  // ------------------------------
  const handleTopicToggle = (topic) => {
    const exists = selectedTopics.some((t) => t.topicname === topic.topicname);

    if (exists) {
      setSelectedTopics(selectedTopics.filter((t) => t.topicname !== topic.topicname));
    } else {
      setSelectedTopics([...selectedTopics, topic]);
    }
  };

  const handleRemoveTopic = (topic, e) => {
    e.stopPropagation();
    setSelectedTopics(selectedTopics.filter((t) => t.topicname !== topic.topicname));
  };

  useEffect(() => {
    // Keep tabFiltersRef synchronized for the active tab
    const activeTab = prevTabRef.current;
    if (activeTab) {
      tabFiltersRef.current[activeTab] = {
        subjects: selectedSubjects,
        exams: selectedExams,
        topics: selectedTopics,
        theme: selectedTheme,
        months: selectedMonths,
        years: selectedYears,
      };
      try {
        sessionStorage.setItem("mcq_tab_filters", JSON.stringify(tabFiltersRef.current));
      } catch (e) {}
    }

    props.onFilterChange?.({
      testtype: selectedExams.map((exam) =>
        exam.examname === "Full" ? "Full" : "Sectional"
      ),
      subject: selectedSubjects,
      topic: selectedTopics.map((t) => t.topicname),
      year: selectedYears.map(Number),
      month: selectedMonths.map((m) => months.indexOf(m) + 1).filter((n) => n > 0),
    });
  }, [selectedExams, selectedSubjects, selectedTopics, selectedMonths, selectedYears, selectedTheme]);

  // by sudz - 260926 - Compact multi-select label to prevent stretching
  const renderMultiSelectLabel = (items, placeholder, onRemove, getKey = (x) => x) => {
    if (!items || items.length === 0) {
      return <span className="placeholder-dropdown">{placeholder}</span>;
    }
    const firstItem = items[0];
    const firstText = getKey(firstItem);
    const moreCount = items.length - 1;
    const allTitles = items.map(getKey).join(", ");

    return (
      <div className="selected-tags-summary" title={allTitles}>
        <div className="selected-item-tag">
          <span className="tag-text">{firstText}</span>
          <button
            type="button"
            className="delete-icon"
            onClick={(e) => onRemove(firstItem, e)}
            aria-label={`Remove ${firstText}`}
          >
            <img src="/assets/images/delete-icon.svg" alt="" />
          </button>
        </div>
        {moreCount > 0 && (
          <span className="more-count-badge" title={items.slice(1).map(getKey).join(", ")}>
            +{moreCount}
          </span>
        )}
      </div>
    );
  };

  return (
    <div className="dropdown-container">



    { (props.selectedExamType !="Current Affairs") && <div className="dropdown-wrapper wrapper-test-type" ref={dropdownRefexamtype}>

      <div
        className={`dropdown-header ${isExamTypeOpen ? "is-open" : ""}`}
        onClick={() => setIsExamTypeOpen(!isExamTypeOpen)}
      >
        <span className="dropdown-label">
          {renderMultiSelectLabel(selectedExams, "Test Type", handleRemoveExam, (e) => e.examname)}
        </span>
        <span className="dropdown-arrow">
          {selectedExams.length > 0 && (
            <span>
              <img
                src="/assets/images/delete-icon.svg"
                alt=""
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedExams([]);
                  setSelectedTopics([]);
                }}
              />
            </span>
          )}
          {isExamTypeOpen ? (
            <img
              src="/assets/images/dropdown-icon.svg"
              alt=""
              style={{ transform: "rotate(0deg)", transition: "0.3s" }}
            />
          ) : (
            <img
              src="/assets/images/dropdown-icon.svg"
              alt=""
              style={{ transform: "rotate(180deg)", transition: "0.3s" }}
            />
          )}
        </span>
      </div>

      {isExamTypeOpen && (
        <div className="dropdown-menu-custom">
          {examtype.map((exam, index) => {
            const isSelected = selectedExams.some(item => item.examname === exam.examname);
            return (
              <div
                key={index}
                className={`checkbox-item ${isSelected ? "item-checked" : ""}`}
                onClick={() => handleExamToggle(exam)}
              >
                <span className={`select-dot ${isSelected ? "dot-checked" : ""}`} />
                <span className='filter-item-name'>{exam.examname}{exam.type === 'pro' && <img src='/assets/images/pro-button-mytest.svg' alt="PRO"/>   }</span>
              </div>
            );
          })}
        </div>
      )}
    </div>}
{/* {(props.selectedExamType ==="pyqs" &&props.selectedExamType !="Current Affairs") &&  <div className="dropdown-wrapper">

     
      <div
        className={`dropdown-header ${!isSectionalSelected ? "disabled" : ""}`}
         onClick={() => {
    if (isSectionalSelected) setIsThemeOpen(!isThemeOpen);
    
  }}
   
      >
        <span className="dropdown-label">
          {selectedTheme.length > 0 ? (
            selectedTheme.map((month, index) => (
              <div key={index} className="selected-item-tag">
                <span className="tag-text">{month}</span>

                <button
                  className="delete-icon"
                  onClick={(e) => handleRemoveTheme(month, e)}
                  aria-label={`Remove ${month}`}
                >
                  <img src="/assets/images/delete-icon.svg" alt="" />
                </button>
              </div>
            ))
          ) : (
            <span className='placeholder-dropdown'>Theme</span>
          )}
        </span>

        <span className="dropdown-arrow">
          {isThemeOpen ? (
            <img
              src="/assets/images/dropdown-icon.svg"
              alt=""
              style={{ transform: "rotate(0deg)", transition: "0.3s" }}
            />
          ) : (
            <img
              src="/assets/images/dropdown-icon.svg"
              alt=""
              style={{ transform: "rotate(180deg)", transition: "0.3s" }}
            />
          )}
        </span>
      </div>

      
      {(isThemeOpen && isSectionalSelected)  && (
        <div className="dropdown-menu-custom">
          {theme.map((month, index) => (
            <div
              key={index}
              className="checkbox-item"
              onClick={() => handleThemeToggle(month)}
            >
              <span>{month}</span>

              <input
                type="checkbox"
                checked={selectedTheme.includes(month)}
                readOnly
                className="dropdown-checkbox"
              />
            </div>
          ))}
        </div>
      )}
    </div>} */}

{/* by sudz:260925 - Activated Subject filter */}
{ (props.selectedExamType !== "Current Affairs") && <div className="dropdown-wrapper wrapper-subject" ref={dropdownRefsubjectype}>
        <div 
          className={`dropdown-header ${isSubjectOpen ? "is-open" : ""}`}
          onClick={() => setIsSubjectOpen(!isSubjectOpen)}
        >
          <span className="dropdown-label">
            {renderMultiSelectLabel(selectedSubjects, "Subject", handleRemoveSubject, (s) => s)}
          </span>
          <span className="dropdown-arrow">
            {selectedSubjects.length > 1 && (
              <span>
                <img
                  src="/assets/images/delete-icon.svg"
                  alt=""
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelectedSubjects([]);
                    setTopicsname([]);
                    setSelectedTopics([]);
                  }}
                />
              </span>
            )}
            <img
              src="/assets/images/dropdown-icon.svg"
              alt=""
              style={{
                transform: isSubjectOpen ? "rotate(0deg)" : "rotate(180deg)",
                transition: "0.3s"
              }}
            />
          </span>
        </div>
        {isSubjectOpen && (
          <div className="dropdown-menu-custom">
            {subjects.map((subject, index) => {
              const isSelected = selectedSubjects.includes(subject);
              return (
                <div
                  key={index}
                  className={`checkbox-item ${isSelected ? "item-checked" : ""}`}
                  onClick={() => handleSubjectToggle(subject)}
                >
                  <span className={`select-dot ${isSelected ? "dot-checked" : ""}`} />
                  <span className='filter-item-name'>{subject}</span>
                </div>
              );
            })}
          </div>
        )}
      </div>}

 {/* by sudz:260925 - Topic filter visible only after subject chosen */}
 {(props.selectedExamType !== "Current Affairs") && selectedSubjects.length > 0 && <div className="dropdown-wrapper wrapper-topic" ref={dropdownReftopictype}>
      <div
        className={`dropdown-header ${isTopicOpen ? "is-open" : ""}`}
        onClick={() => setIsTopicOpen(!isTopicOpen)}
      >
        <span className="dropdown-label">
          {renderMultiSelectLabel(selectedTopics, "Topic", handleRemoveTopic, (t) => t.topicname)}
        </span>
  
        <span className="dropdown-arrow">
          {selectedTopics.length > 1 && (
            <span>
              <img
                src="/assets/images/delete-icon.svg"
                alt=""
                onClick={(e) => { e.stopPropagation(); setSelectedTopics([]); }}
              />
            </span>
          )}
          <img
            src="/assets/images/dropdown-icon.svg"
            alt=""
            style={{
              transform: isTopicOpen ? "rotate(0deg)" : "rotate(180deg)",
              transition: "0.3s"
            }}
          />
        </span>
      </div>

      {isTopicOpen && (
        <div className="dropdown-menu-custom">
          {topicsname.map((topic, index) => {
            const isSelected = selectedTopics.some(
              item => item.topicname === topic.topicname
            );
            return (
              <div
                key={index}
                className={`checkbox-item ${isSelected ? "item-checked" : ""}`}
                onClick={() => handleTopicToggle(topic)}
              >
                <span className={`select-dot ${isSelected ? "dot-checked" : ""}`} />
                <span className='filter-item-name'>{topic.topicname}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>}


    {(props.selectedExamType ==="Current Affairs")&& <div className="dropdown-wrapper wrapper-month" ref={dropdownRefmonthtype}>

      <div
        className={`dropdown-header ${isMonthOpen ? "is-open" : ""}`}
        onClick={() => setIsMonthOpen(!isMonthOpen)}
      >
        <span className="dropdown-label">
          {renderMultiSelectLabel(selectedMonths, "Select Month", handleRemoveMonth, (m) => m)}
        </span>

        <span className="dropdown-arrow">
          <img
            src="/assets/images/dropdown-icon.svg"
            alt=""
            style={{
              transform: isMonthOpen ? "rotate(0deg)" : "rotate(180deg)",
              transition: "0.3s"
            }}
          />
        </span>
      </div>

      {isMonthOpen && (
        <div className="dropdown-menu-custom">
          {months.map((month, index) => {
            const isSelected = selectedMonths.includes(month);
            return (
              <div
                key={index}
                className={`checkbox-item ${isSelected ? "item-checked" : ""}`}
                onClick={() => handleMonthToggle(month)}
              >
                <span className={`select-dot ${isSelected ? "dot-checked" : ""}`} />
                <span className='filter-item-name'>{month}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>}
    { (props.selectedExamType ==="Current Affairs")&&  <div className="dropdown-wrapper wrapper-year" ref={dropdownRefyeartype}>

      <div
        className={`dropdown-header ${isYearOpen ? "is-open" : ""}`}
        onClick={() => setIsYearOpen(!isYearOpen)}
      >
        <span className="dropdown-label">
          {renderMultiSelectLabel(selectedYears, "Select Year", handleRemoveYear, (y) => y)}
        </span>

        <span className="dropdown-arrow">
          <img
            src="/assets/images/dropdown-icon.svg"
            alt=""
            style={{
              transform: isYearOpen ? "rotate(0deg)" : "rotate(180deg)",
              transition: "0.3s"
            }}
          />
        </span>
      </div>

      {isYearOpen && (
        <div className="dropdown-menu-custom">
          {years.map((year, index) => {
            const isSelected = selectedYears.includes(year);
            return (
              <div
                key={index}
                className={`checkbox-item ${isSelected ? "item-checked" : ""}`}
                onClick={() => handleYearToggle(year)}
              >
                <span className={`select-dot ${isSelected ? "dot-checked" : ""}`} />
                <span className='filter-item-name'>{year}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>}
    {hasActiveFilters && <span className="clear-all-filter"  onClick={clear}>Clear all filters</span>}
    </div>
  );
};

export default CustomDropdown;